export default "__VITE_ASSET__aRhJcMjn__"